import { ConditionOperatorEnumType } from '@reach/shared-types/conditions';
import { useState } from 'react';
import { BetweenDateBuilder } from '../BetweenDateBuilder';
import styles from '../SegmentVisualBuilder.module.css';
import { DateValueModeToggle } from './DateValueModeToggle';
import { ResolvedDatePreview } from './ResolvedDatePreview';
import { getDateValueMode, isBetweenDate } from './date-value-utils';
import type { DateOperatorInputProps, DateValueMode } from './types';

export function BetweenDateInput({ operator, value, onChange, disabled }: DateOperatorInputProps) {
  const betweenValue = value != null && isBetweenDate(value) ? value : null;
  const [selectedDateValueMode, setSelectedDateValueMode] = useState<DateValueMode | null>(null);
  const isRecurringDateRange = operator === ConditionOperatorEnumType.BETWEEN_MONTH_DAY;
  const derivedDateValueMode = getDateValueMode(betweenValue?.startDate);
  const dateValueMode = derivedDateValueMode ?? selectedDateValueMode ?? 'absolute';

  const handleDateValueModeChange = (nextDateValueMode: DateValueMode) => {
    setSelectedDateValueMode(nextDateValueMode);
    onChange([]);
  };

  if (isRecurringDateRange) {
    return (
      <div className={styles.dateVariantWrapper}>
        <BetweenDateBuilder
          value={betweenValue}
          onChange={between => onChange([between])}
          disabled={disabled}
          dateValueMode="absolute"
          monthDayOnly
        />
        <ResolvedDatePreview operator={operator} value={value} />
      </div>
    );
  }

  return (
    <div className={styles.dateVariantWrapper}>
      <DateValueModeToggle
        dateValueMode={dateValueMode}
        onChange={handleDateValueModeChange}
        disabled={disabled}
      />
      <BetweenDateBuilder
        value={betweenValue}
        onChange={between => onChange([between])}
        disabled={disabled}
        dateValueMode={dateValueMode}
      />
      <ResolvedDatePreview operator={operator} value={value} />
    </div>
  );
}
